export type LoadingType = "straight" | "turned" | "pinwheel";

export type LimitingFactor = "space" | "weight";

export type GeometryCategory =
  | "stringer-pallet"
  | "block-pallet"
  | "box"
  | "cylinder"
  | "ibc-cage"
  | "spool"
  | "bulk-bag"
  | "bale"
  | "crate";

export type TruckCategory =
  | "enclosed"
  | "flatbed"
  | "box-truck"
  | "container"
  | "van"
  | "drop-deck";

export interface TruckSpec {
  id: string;
  label: string;
  lengthIn: number;
  widthIn: number;
  heightIn: number;
  maxWeightLbs: number;
  skidSpots: number | null;
  group: "popular" | "other";
  category: TruckCategory;
}

export interface ItemDimensions {
  lengthIn: number;
  widthIn: number;
  heightIn: number;
  weightLbs: number;
  geometryCategory: GeometryCategory;
  stackable: boolean;
  palletized: boolean;
  palletHeightIn: number;
}

export const DEFAULT_PALLET_HEIGHT_IN = 5;

export interface FitResult {
  floorCount: number;
  stackLayers: number;
  totalBySpace: number;
  totalByWeight: number;
  totalFits: number;
  limitingFactor: LimitingFactor;
  spaceUtilization: number;
  weightUtilization: number;
}

export interface ItemPosition {
  x: number;
  y: number;
  z: number;
  rotationY: number;
}

export const CYLINDER_CATEGORIES = new Set<GeometryCategory>([
  "cylinder",
  "spool",
]);

export function isCylindrical(item: ItemDimensions): boolean {
  return CYLINDER_CATEGORIES.has(item.geometryCategory);
}

export function toNumber(value: string): number {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
}
